<script>
export default {
    name: 'smile-with-text',

    props: {
        icon: String,
        header: String,
        text: String,
        faType: String,
    },
}

</script>

<template lang="html">
    <div class="smile-with-text text-center">
        <i  :class=" faType + ' fa-' + icon" :id="faType + icon" class="fa-10x"></i>
        <div class="text-xxl mb-3">
            {{ header }}
        </div>
        <div class="font-weight-semibold">
            {{ text }}
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/elements/SmileWithText.vue